import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { MessageService } from 'app/common/message.service';
import { TranslateConfigService } from 'app/common/translate/translate-config.service';
import { catchError } from 'rxjs';

const ignoredUrls = ['/timer-worked-entries/emitter', '/users/authenticate', '/users/login'];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (shouldIgnoreUrl(req.url)) {
        throw error;
      }

      const translateConfigService = injector.get(TranslateConfigService);
      const errorMessage =
        translateConfigService.getTranslation('general.errorOccurred') + ': ' + error.message;

      const messageService = injector.get(MessageService);
      messageService.showError(errorMessage);
      throw error;
    })
  );
};

function shouldIgnoreUrl(url: string): boolean {
  return ignoredUrls.some((ignoredUrl) => url.includes(ignoredUrl));
}
